function AuthFactory(container) {
  class UserLoginForm {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.form = container;
      this.form_validation;
      this.inputEmail = this.form.querySelector('[name="customer[email]"]');
      this.inputPass = this.form.querySelector('[name="customer[password]"]');

      this._init();
    }
    _init() {
      this._setEvents();
      this._setInputValues();
      this._setInputValidation();
    }
    _setEvents() {
      let userEmailSubmitBtnList =
        this.form.querySelectorAll('[type="submit"]');
      // let userEmailSubmitBtnList = document.querySelectorAll('[data-login-step="user_email"] [data-action="next_step"]');

      for (const userEmailSubmitBtn of userEmailSubmitBtnList) {
        userEmailSubmitBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.target.classList.add("is-loading");
          try {
            const formIsValid = await this._validateForm();
            if (formIsValid) {
              this.form.submit();
            }
          } catch (error) {
            console.error("Error fetching customer status:", error);
          }
          e.target.classList.remove("is-loading");
        });
      }
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _setInputValues(customerEmail) {
      if (this.inputEmail && customerEmail) {
        this.customerEmail = customerEmail;
        this.inputEmail.value = this.customerEmail;
        this.inputEmail.readOnly = true;
      }
    }
    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ["Form__Input--valid"],
        successFieldCssClass: ["Form__Input--valid"],
        errorLabelCssClass: ["Form__Input--invalid"],
        errorFieldCssClass: ["Form__Input--invalid"],
        successFieldGroupCssClass: ["Form__Item--invalid"],
        errorFieldGroupCssClass: ["Form__Item--invalid"],
      });
      validation
        .addField(this.inputEmail, [
          {
            rule: "required",
            errorMessage: "Digite um email",
          },
          {
            rule: "email",
            errorMessage: "Digite um email válido",
          },
        ])
        .addField(this.inputPass, [
          {
            rule: "required",
            errorMessage: "Digite uma senha",
          },
        ]);
      this.form_validation = validation;
    }
  }
  class UserRecoverPasswordForm {
    constructor(container, userEmail) {
      this.form = container;
      this.form_validation;
      this.userEmail = userEmail;
      this.inputEmail = this.form.querySelector('[name="email"]');

      this._init();
    }
    _init() {
      if (this.userEmail) {
        this.inputEmail.value = this.userEmail;
      }
      this._setEvents();
      this._setInputValidation();
    }
    _setEvents() {
      let userEmailSubmitBtnList =
        this.form.querySelectorAll('[type="submit"]');

      for (const userEmailSubmitBtn of userEmailSubmitBtnList) {
        userEmailSubmitBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.target.classList.add("is-loading");
          try {
            const formIsValid = await this._validateForm();
            if (formIsValid) {
              this.form.submit();
            }
          } catch (error) {
            console.error("Error fetching customer status:", error);
          }
          e.target.classList.remove("is-loading");
        });
      }
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _setInputValues(userEmail) {
      if (this.inputEmail && userEmail) {
        this.userEmail = userEmail;
        this.inputEmail.value = this.userEmail;
      }
    }
    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ["Form__Input--valid"],
        successFieldCssClass: ["Form__Input--valid"],
        errorLabelCssClass: ["Form__Input--invalid"],
        errorFieldCssClass: ["Form__Input--invalid"],
        successFieldGroupCssClass: ["Form__Item--invalid"],
        errorFieldGroupCssClass: ["Form__Item--invalid"],
      });
      validation.addField(this.inputEmail, [
        {
          rule: "required",
          errorMessage: "Digite um email",
        },
        {
          rule: "email",
          errorMessage: "Digite um email válido",
        },
      ]);
      this.form_validation = validation;
    }
  }
  class UserResetPasswordForm {
    constructor(container) {
      this.form = container;
      this.form_validation;
      this.inputPass = this.form.querySelector('[name="customer[password]"]');
      this.inputCPass = this.form.querySelector(
        '[name="customer[password_confirmation]"]'
      );

      this._init();
    }
    _init() {
      this._setEvents();
      this._setInputValidation();
    }
    _setEvents() {
      let userEmailSubmitBtnList =
        this.form.querySelectorAll('[type="submit"]');

      for (const userEmailSubmitBtn of userEmailSubmitBtnList) {
        userEmailSubmitBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.target.classList.add("is-loading");
          try {
            const formIsValid = await this._validateForm();
            if (formIsValid) {
              this.form.submit();
            }
          } catch (error) {
            console.error("Error fetching customer status:", error);
          }
          e.target.classList.remove("is-loading");
        });
      }
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ["Form__Input--valid"],
        successFieldCssClass: ["Form__Input--valid"],
        errorLabelCssClass: ["Form__Input--invalid"],
        errorFieldCssClass: ["Form__Input--invalid"],
        successFieldGroupCssClass: ["Form__Item--invalid"],
        errorFieldGroupCssClass: ["Form__Item--invalid"],
      });
      validation
        .addField(this.inputPass, [
          {
            rule: "required",
            errorMessage: "Digite uma senha de no mínimo 8 caracteres",
          },
          {
            rule: "minLength",
            value: 8,
            errorMessage: "Digite uma senha de no mínimo 8 caracteres",
          },
          {
            rule: "password",
          },
        ])
        .addField(this.inputCPass, [
          {
            rule: "required",
            errorMessage: "Confirme sua senha",
          },
          {
            rule: "password",
            errorMessage: "Digite uma senha válida",
          },
          {
            validator: (value, fields) => {
              if (fields[this.inputPass] && fields[this.inputPass].elem) {
                const repeatPasswordValue = fields[this.inputPass].elem.value;

                return value === repeatPasswordValue;
              }

              return true;
            },
            errorMessage: "As senhas precisam ser iguais",
          },
        ]);
      this.form_validation = validation;
    }
  }
  class UserVerificationForm {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.form = container;
      this.form_validation;
      this.inputEmail = this.form.querySelector('[name="customer[email]"]');

      this._init();
    }
    _init() {
      this._setEvents();
      this._setInputValidation();
    }
    _setEvents() {
      let userEmailSubmitBtnList =
        this.form.querySelectorAll('[type="submit"]');

      for (const userEmailSubmitBtn of userEmailSubmitBtnList) {
        userEmailSubmitBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.target.classList.add("is-loading");

          try {
            const customerEmail = document.querySelector(
              '[name="customer[email]"]'
            ).value;

            const formIsValid = await this._validateForm();

            if (formIsValid && customerEmail) {
              const customerStatus =
                await window.SimpleCore.customer_auth.status(customerEmail);

              window.SimpleCore._helpers.triggerEvent(
                "auth:user_verification:success",
                {
                  email: customerStatus.email || customerEmail,
                  status: customerStatus.status,
                }
              );
              e.target.classList.remove("is-loading");
            }
          } catch (error) {
            console.error("Error fetching customer status:", error);
          }
        });
      }
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ["Form__Input--valid"],
        successFieldCssClass: ["Form__Input--valid"],
        errorLabelCssClass: ["Form__Input--invalid"],
        errorFieldCssClass: ["Form__Input--invalid"],
        successFieldGroupCssClass: ["Form__Item--invalid"],
        errorFieldGroupCssClass: ["Form__Item--invalid"],
      });
      validation.addField(this.inputEmail, [
        {
          rule: "required",
          errorMessage: "Digite um email",
        },
        {
          rule: "email",
          errorMessage: "Digite um email válido",
        },
      ]);
      this.form_validation = validation;
    }
  }
  class UserRegisterForm {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.form = container;
      this.form_validation;
      this.customerEmail = customerEmail;
      this.customerFirstName = customerFirstName;
      this.customerLastName = customerLastName;

      this.inputEmail = this.form.querySelector('[name="customer[email]"]');
      this.inputFirstName = this.form.querySelector(
        '[name="customer[first_name]"]'
      );
      this.inputLastName = this.form.querySelector(
        '[name="customer[last_name]"]'
      );
      this.inputPass = this.form.querySelector('[name="customer[password]"]');
      this.inputCPass = this.form.querySelector(
        '[name="customer[password_confirm]"]'
      );

      this._init();
    }
    _init() {
      this._setEvents();
      this._setInputValues();
      this._setInputValidation();
    }
    _setEvents() {
      let userRegisterBtnList = this.form.querySelectorAll('[type="submit"]');
      for (const userRegisterBtn of userRegisterBtnList) {
        userRegisterBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.target.classList.add("is-loading");
          try {
            let matchingPass = await this._validateForm();
            if (matchingPass) {
              this.form.submit();
            }
          } catch (error) {
            alert(error.message);
          }
          e.target.classList.remove("is-loading");
        });
      }
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _setInputValues(customerEmail, customerFirstName, customerLastName) {
      if (this.inputEmail && customerEmail) {
        this.customerEmail = customerEmail;
        this.inputEmail.value = this.customerEmail;
        this.inputEmail.readOnly = true;
      }
      if (this.inputFirstName && customerFirstName) {
        this.customerFirstName = customerFirstName;
        this.inputFirstName.value = this.customerFirstName;
        this.inputFirstName.readOnly = true;
      }
      if (this.inputLastName && customerLastName) {
        this.customerLastName = customerLastName;
        this.inputLastName.value = this.customerLastName;
        this.inputLastName.readOnly = true;
      }
    }
    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ["Form__Input--valid"],
        successFieldCssClass: ["Form__Input--valid"],
        errorLabelCssClass: ["Form__Input--invalid"],
        errorFieldCssClass: ["Form__Input--invalid"],
        successFieldGroupCssClass: ["Form__Item--invalid"],
        errorFieldGroupCssClass: ["Form__Item--invalid"],
      });
      validation
        .addField(this.inputEmail, [
          {
            rule: "required",
            errorMessage: "Digite um email",
          },
          {
            rule: "email",
            errorMessage: "Digite um email válido",
          },
        ])
        .addField(this.inputFirstName, [
          {
            rule: "required",
            errorMessage: "Digite uma nome de no mínimo 3 caracteres",
          },
          {
            rule: "minLength",
            value: 3,
            errorMessage: "Digite uma nome de no mínimo 3 caracteres",
          },
        ])
        .addField(this.inputLastName, [
          {
            rule: "required",
            errorMessage: "Digite uma sobrenome de no mínimo 3 caracteres",
          },
          {
            rule: "minLength",
            value: 3,
            errorMessage: "Digite uma sobrenome de no mínimo 3 caracteres",
          },
        ])
        .addField(this.inputPass, [
          {
            rule: "required",
            errorMessage: "Digite uma senha de no mínimo 8 caracteres",
          },
          {
            rule: "minLength",
            value: 8,
            errorMessage: "Digite uma senha de no mínimo 8 caracteres",
          },
          {
            rule: "password",
          },
        ])
        .addField(this.inputCPass, [
          {
            rule: "required",
            errorMessage: "Confirme sua senha",
          },
          {
            rule: "password",
            errorMessage: "Digite uma senha válida",
          },
          {
            validator: (value, fields) => {
              if (fields[this.inputPass] && fields[this.inputPass].elem) {
                const repeatPasswordValue = fields[this.inputPass].elem.value;

                return value === repeatPasswordValue;
              }

              return true;
            },
            errorMessage: "As senhas precisam ser iguais",
          },
        ]);
      this.form_validation = validation;
    }
  }

  let Auth = class {
    constructor(container) {
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.customerVerificationStep = this.element.querySelector(
        '[data-step="verification"]'
      );
      this.customerLoginStep = this.element.querySelector(
        '[data-step="login"]'
      );
      this.recoverPasswordStep = this.element.querySelector(
        '[data-step="recover-password"]'
      );

      this.resetPasswordForm = new UserResetPasswordForm(
        this.element.querySelector(`[data-step="reset_password"] form`)
      );
      this.recoverPasswordForm = new UserRecoverPasswordForm(
        this.element.querySelector(
          `[data-step="recover_password"] [name="recover"]`
        )
      );
      this.customerVerificationForm = new UserVerificationForm(
        this.element.querySelector(`[data-step="verification"] form`)
      );
      this.customerLoginForm = new UserLoginForm(
        this.element.querySelector(`[data-step="login"] form`)
      );
      this.customerCompleteRegisterForm = new UserRegisterForm(
        this.element.querySelector(`[data-step="complete-register"] form`)
      );
      this.customerRegisterForm = new UserRegisterForm(
        this.element.querySelector(`[data-step="register"] form`)
      );

      this.delegateElement.on(
        "click",
        '[data-action="toggle-recover-form"]',
        this._showRecoverPassword.bind(this)
      );
      this._initLoginForm();
    }

    _initLoginForm() {
      window.SimpleCore._helpers.checkVariable("axios").then((exists) => {
        if (exists) {
          window.SimpleCore.customer_auth._init();
          this._setEvents();
        } else {
          // console.log('Variable does not exist or was not defined within the timeout.');
        }
      });
    }

    _setAuthStep(step_id) {
      try {
        let authSteps = this.element.querySelectorAll("[data-step]");
        let stepToActivate = this.element.querySelector(
          `[data-step="${step_id}"]`
        );
        if (stepToActivate) {
          for (const authStep of authSteps) {
            authStep.classList.remove("--active");
          }
          stepToActivate.classList.add("--active");
        }
      } catch (error) {
        throw new Error(error.message);
      }
    }

    _setLoginStep(customerEmail) {
      try {
        this._setAuthStep("login");
        this.customerLoginForm._setInputValues(customerEmail);
        this.recoverPasswordForm._setInputValues(customerEmail);
      } catch (error) {
        throw new Error(error.message);
      }
    }

    _setUserCompleteRegisterStep(
      customerEmail,
      customerFirstName,
      customerLastName
    ) {
      try {
        this._setAuthStep("complete-register");
        this.customerCompleteRegisterForm._setInputValues(
          customerEmail,
          customerFirstName,
          customerLastName
        );
      } catch (error) {
        throw new Error(error.message);
      }
    }

    _setUserRecoverPassStep(customerEmail) {
      this._setAuthStep("recover_password");
    }

    _setUserResetPassStep(customerEmail) {
      this._setAuthStep("reset_password");
    }

    _setUserRegistrationStep() {
      this._setAuthStep("register");
    }

    _setEvents() {
      let $this = this;
      let user_status;
      let customerLoginBtnList = document.querySelectorAll(
        '[data-goto="login"]'
      );
      let customerRegistrationBtnList = document.querySelectorAll(
        '[data-goto="user_registration"]'
      );
      let customerRecoverPassBtnList = document.querySelectorAll(
        '[data-goto="recover_password"]'
      );
      let customerResetPassBtnList = document.querySelectorAll(
        '[data-goto="reset_password"]'
      );

      function handleCustomerStatus(statusObj) {
        switch (statusObj.status) {
          case "enabled":
            $this._setLoginStep(statusObj.email);
            break;
          case "disabled":
            $this._setUserCompleteRegisterStep(statusObj.email);
            break;
          case "not_found":
          default:
            $this._setUserRegistrationStep(statusObj.email);
            break;
        }
      }

      for (const customerRegistrationBtn of customerRegistrationBtnList) {
        customerRegistrationBtn.addEventListener("click", async (e) => {
          try {
            e.preventDefault();
            e.target.classList.add("is-loading");
            $this._setUserRegistrationStep(user_status?.email);
            e.target.classList.remove("is-loading");
          } catch (error) {
            throw new Error(error.message);
          }
        });
      }
      for (const customerRecoverPassBtn of customerRecoverPassBtnList) {
        customerRecoverPassBtn.addEventListener("click", async (e) => {
          try {
            e.preventDefault();
            e.target.classList.add("is-loading");
            $this._setUserRecoverPassStep(user_status?.email);
            e.target.classList.remove("is-loading");
          } catch (error) {
            throw new Error(error.message);
          }
        });
      }
      for (const customerResetPassBtn of customerResetPassBtnList) {
        customerResetPassBtn.addEventListener("click", async (e) => {
          try {
            e.preventDefault();
            e.target.classList.add("is-loading");
            $this._setUserResetPassStep(user_status?.email);
            e.target.classList.remove("is-loading");
          } catch (error) {
            throw new Error(error.message);
          }
        });
      }
      for (const customerLoginBtn of customerLoginBtnList) {
        customerLoginBtn.addEventListener("click", async (e) => {
          try {
            e.preventDefault();
            e.target.classList.add("is-loading");
            $this._setLoginStep(user_status?.email);
            e.target.classList.remove("is-loading");
          } catch (error) {
            throw new Error(error.message);
          }
        });
      }
      document.addEventListener("so.auth:user_verification:success", (e) => {
        try {
          user_status = e.detail;
          handleCustomerStatus(user_status);
        } catch (error) {
          throw new Error(error.message);
        }
      });
      if (window.location.href.includes("/account/reset")) {
        $this._setUserResetPassStep();
      }
      if (window.location.href.includes("/account/register")) {
        $this._setUserRegistrationStep();
      }
    }

    _showRecoverPassword() {
      var isLoginActive = this.customerLoginStep.style.display !== "none";

      if (isLoginActive) {
        this.customerLoginStep.style.display = "none";
        this.recoverPasswordStep.style.display = "block";
      } else {
        this.customerLoginStep.style.display = "block";
        this.recoverPasswordStep.style.display = "none";
      }
    }
  };
  return new Auth(container);
}
